import { Button } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'

type Props = {
  image: string
  webImage?: string
  isLoading: boolean
  disabled?: boolean
}

const t = buildTranslate('cms.content.banners.sidebar')

const Sidebar = ({ isLoading, disabled, image, webImage }: Props) => {
  const [css] = useStyletron()

  return (
    <>
      <Button
        className={`mb-xxxl px-s ${css({ width: '200px' })}`}
        isLoading={isLoading}
        disabled={disabled}
        type={'submit'}
      >
        {t('publish')}
      </Button>
      <p className="body-text-4 grey-70 text-center">{t('how_it_looks_app')}</p>
      <img
        className={`mt-x ${css({
          width: '200px',
        })}`}
        src={image}
        alt={t('mobile_preview')}
      />
      {webImage && (
        <>
          <p className="body-text-4 grey-70 mt-xl text-center">
            {t('how_it_looks_desktop')}
          </p>
          <img
            className={`mt-x ${css({
              width: '200px',
            })}`}
            src={webImage}
            alt={t('web_preview')}
          />
        </>
      )}
    </>
  )
}

export default Sidebar
